import { useQueryClient } from "@tanstack/react-query";
import { Modal, Button, Input, Form, notification } from "antd";
import apiClient from "QueryClient/axiosClient";
import { useState } from "react";
export const AddCollegeModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const queryClient = useQueryClient();
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const onFinish = async (values) => {
    try {
      await apiClient.post("/undergradColleges", values); // Adjust the URL to your backend API
      notification.success({
        message: "Success",
        description: "College added successfully!",
      });
      handleCancel(); // Close the modal after success
      queryClient.invalidateQueries({ queryKey: ["colleges"] });
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Failed to add college. Please try again later.",
      });
    }
  };

  return (
    <>
      <Button type="primary" onClick={showModal} style={{ marginTop: "10px" }}>
        Add College
      </Button>
      <Modal
        title="Add College"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="College name"
            name="name"
            rules={[
              { required: true, message: "Please enter the college name" },
            ]}
          >
            <Input placeholder="Enter college name" />
          </Form.Item>

          <Form.Item
            label="College Website"
            name="website"
            rules={[
              { required: true, message: "Please enter the college website" },
              { type: "url", message: "Please enter a valid URL" },
            ]}
          >
            <Input placeholder="Enter college website" />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            style={{ marginTop: "10px" }}
          >
            Submit
          </Button>
        </Form>
      </Modal>
    </>
  );
};
